import React from 'react';
import PropTypes from 'prop-types';

export default function SearchField({ placeholder, value, onChange }) {
  return (
    <input
      type="text"
      className="form__control input--item-search"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
}

SearchField.displayName = 'SearchField';

SearchField.propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
};

SearchField.defaultProps = {
  placeholder: 'Search',
};